var sidebarBannerComponent = function ($) {
    var banner;
    var leavingTimeout;
    var activationOffset;
    var closeIcon;
    var timeoutId;

    function hideBanner() {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        if (!banner.hasClass('animated')) {
            banner.addClass('animated');
        }

        if (banner.hasClass('sidebar-banner--left')) {
            banner.removeClass('fadeInLeft').addClass('fadeOutLeft');
        } else if (banner.hasClass('sidebar-banner--right')) {
            banner.removeClass('fadeInRight').addClass('fadeOutRight');
        }
    }

    function showBanner() {
        banner.addClass('animated');
        if (banner.hasClass('sidebar-banner--left')) {
            banner.addClass('fadeInLeft');
        } else if (banner.hasClass('sidebar-banner--right')) {
            banner.addClass('fadeInRight');
        }

        if (leavingTimeout > 0) {
            timeoutId = setTimeout(hideBanner, leavingTimeout);
        }
    }

    function bindEvents() {
        closeIcon.click(function () {
            hideBanner();
        });

        function showBannerWhenInView() {
            if ((window.innerHeight + window.pageYOffset) >= activationOffset) {
                showBanner();
                $(window).off('scroll', showBannerWhenInView);
            }
        }

        $(window).on('scroll', showBannerWhenInView);
        showBannerWhenInView();
    }

    function init() {
        banner = $('.sidebar-banner');

        if (banner.length === 0) return;

        leavingTimeout = banner.attr('data-timeout');
        activationOffset = banner.attr('data-offset');
        closeIcon = banner.find('.close');

        bindEvents();
    }

    return {
        init: init
    };
}(jQuery);

$(function () {
    sidebarBannerComponent.init();
});